import classNames from 'classnames';
import type { ReactNode } from 'react';

interface IIconWrapper {
  children: ReactNode;
  onClick?: () => void;
  size?: 'sm' | 'lg';
}

export const IconWrapper = ({
  children,
  onClick,
  size = 'lg',
}: IIconWrapper) => (
  <div
    className={classNames('h-full flex justify-center items-center', {
      'w-[30px]': size === 'sm',
      'w-10': size === 'lg',
    })}
  >
    <div
      className={onClick && 'cursor-pointer'}
      onClick={onClick}
    >
      {children}
    </div>
  </div>
);
